module.exports = __webpack_public_path__ + "static/media/unsplash.86aa54ed.png";